var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.39432C19 3.90432 14.74 0.174316 10 0.174316C5.31 0.174316 1 3.82432 1 9.45432C0.4 9.79432 0 10.4343 0 11.1743V13.1743C0 14.2743 0.9 15.1743 2 15.1743H3V9.07432C3 5.20432 6.13 2.07432 10 2.07432C13.87 2.07432 17 5.20432 17 9.07432V16.1743H9V18.1743H17C18.1 18.1743 19 17.2743 19 16.1743V14.9543C19.59 14.6443 20 14.0343 20 13.3143V11.0143C20 10.3143 19.59 9.70432 19 9.39432Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.1743C7.55228 11.1743 8 10.7266 8 10.1743C8 9.62203 7.55228 9.17432 7 9.17432C6.44772 9.17432 6 9.62203 6 10.1743C6 10.7266 6.44772 11.1743 7 11.1743Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.1743C13.5523 11.1743 14 10.7266 14 10.1743C14 9.62203 13.5523 9.17432 13 9.17432C12.4477 9.17432 12 9.62203 12 10.1743C12 10.7266 12.4477 11.1743 13 11.1743Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.20432C15.52 5.35432 13.04 3.17432 10.05 3.17432C7.01997 3.17432 3.75997 5.68432 4.01997 9.62432C6.48997 8.61432 8.34997 6.41432 8.87997 3.73432C10.19 6.36432 12.88 8.17432 16 8.20432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.0d11feaf2be44db918b2b2c72889250f.svg";
export { ForwardRef as ReactComponent };